<template>
  <custom-dialog :visible="visible" width="680px" class="device-warehousing-dialog" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="msg-content">
        <div class="title">{{$t('dms_device_scrap_dialog.she_bei_xin_xi')}}</div>
        <ul class="msg-list">
          <li >
            <div class="key">{{ $t('dms_device_scrap_dialog.chan_pin_xing_hao') }}</div>
            <div class="val">{{ model.data.productCode }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_scrap_dialog.ji_shen_hao') }}</div>
            <div class="val">{{ model.data.bodyNum }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_scrap_dialog.sbywlx') }}</div>
            <div class="val">{{ getDicValue('dms_device_biz_type', model.data.deviceBizType) || '-'  }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_scrap_dialog.ye_wu_zhuang_tai') }}</div>
            <div class="val">{{ getDicValue('order_device_biz_state', model.data.bizState) || '-'}}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_scrap_dialog.ljzlys') }}</div>
            <div class="val">{{ model.data.totalReceivedMonthHq }}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item :label="$t('dms_device_scrap_dialog.bao_fei_yuan_yin')" prop="applyReason">
            <el-input type="textarea" :rows="3"  v-model="form.applyReason"  style="width:100%;">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        applyReason: ''
      },
    };
  },
  mounted: function () {
    this.form.productCode = this.model.data.productCode || '';
  },

  computed: {
    rules() {
      return {
        applyReason: [{
          required: true,
          message: this.$t('dms_device_scrap_dialog.qtxbfyy')
        }],

      };
    },
  },
  methods: {
    changCounty(item) {
      this.form.country = item ? item.name : '';
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.form.deviceId = this.model.data.deviceId;
          this.$postJSON(apis.deviceScrapApply, this.form, true).then((res) => {
            const id = res.data;
            this.$postJSON(`${apis.apsApproveApprovalApproveStart}/device_scrap/${id}`, this.form, true).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success'
              });
              this.visible = false;
              this.clearKeepAlive('stockManage');
              this.$emit('success');
            });


          });

        }
      });
    }
  }
};
</script>

<style lang="scss">
.device-warehousing-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
